// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_pp-8";
export var editMode = "_pp-3";
export var headerRow = "_pp-a";
export var headerTitle = "_pp-b";
export var product = "_pp-1";
export var productDetails = "_pp-5";
export var productDivider = "_pp-7";
export var productImage = "_pp-2";
export var productInfo = "_pp-4";
export var productTitle = "_pp-6";
export var strikethrough = "_pp-9";
export var upsellProductsCard = "_pp-0";